<template>
  <div class="wifi_order_reput">
    <el-form size="mini" :model="reputCondition">
      <el-form-item class="must" label="订单编号">
        <el-select
          size="mini"
          placeholder="请输入"
          v-model="combineCode"
          filterable
          default-first-option
          no-data-text="无匹配订单"
          :loading="remoteLoading"
          @focus.once="focusSearch"
          @change="selectOrder">
          <el-option
            v-for="{value,label} in listOrderCode"
            :key="value"
            :label="label"
            :value="value">
          </el-option>
        </el-select>
        <i class="iconfont icon-biaodan-tianxie"></i>
      </el-form-item>
      <el-form-item class="must" label="投放日期">
        <el-date-picker
          class="input-date"
          type="date"
          v-model="reputCondition.startDate"
          value-format="yyyy-MM-dd"
          placeholder="开始日期"
          prefix-icon="el-icon-arrow-down"
          :clearable="false"
          :disabled="dateDisable"
          :picker-options="startPickerOptions"
          @change="startDateChange">
        </el-date-picker>
        <span>-</span>
        <el-date-picker
          class="input-date"
          type="date"
          v-model="reputCondition.endDate"
          value-format="yyyy-MM-dd"
          placeholder="结束日期"
          prefix-icon="el-icon-arrow-down"
          :clearable="false"
          :disabled="dateDisable"
          :picker-options="endPickerOptions"
          @change="endDateChange">
        </el-date-picker>
        <i class="iconfont icon-biaodan-shijian"></i>
      </el-form-item>
      <el-form-item class="must custom" label="合同编码">
        <el-input placeholder="请输入正确的合同编码" :maxlength="30" v-model="reputCondition.contractNo" @blur="contractHandle" @keyup.enter.native="contractHandle">
          <i slot="suffix" class="iconfont icon-biaodan-tianxie"></i>
        </el-input>
      </el-form-item>
    </el-form>
    <div class="search" @click="search">查找Wi-Fi广告</div>
  </div>
</template>

<script>
import { searchOrderCode } from '@/utils/api'

const ONEDAY = 24 * 3600000
const dateNow = new Date()

export default {
  name: 'ReputOrderCondition',
  data () {
    let vm = this
    return {
      remoteLoading: false, // 是否正在从远程获取数据
      listOrderCode: [],
      combineCode: '',
      reputCondition: {
        orderCode: '',
        startDate: '',
        endDate: '',
        contractNo: ''
      },
      startPickerOptions: {
        disabledDate (t) {
          const dt = new Date(t)
          return dt - dateNow < -ONEDAY || dt - dateNow > 89 * ONEDAY
        }
      },
      endPickerOptions: {
        disabledDate (d) {
          const dt = new Date(d)
          const theStart = new Date(vm.reputCondition.startDate)
          return dt - theStart - 89 * dayMs > 0 || dt - theStart < -dayMs || dt - dateNow > 89 * dayMs
        }
      }
    }
  },
  computed: {
    dateDisable () {
      return !this.combineCode
    }
  },
  methods: {
    focusSearch (e) { // input初次获得焦点时触发订单搜索
      this.orderSearchRemote('')
    },
    async orderSearchRemote (orderCode) {
      this.remoteLoading = true
      let res = await searchOrderCode({ orderCode })
      this.remoteLoading = false
      if (res && res.code === 0) {
        if (res.data && res.data.length) {
          this.listOrderCode = res.data.map(({ orderCode, startDate, endDate }) => {
            let combineV = orderCode + ',' + startDate + ',' + endDate
            return {
              value: combineV,
              label: orderCode
            }
          })
        } else {
          this.listOrderCode = []
        }
      }
    },
    selectOrder (val) {
      let [ orderCode, startDate, endDate ] = val.split(',')
      this.reputCondition = { orderCode, startDate, endDate, contractNo: '' }
    },
    startDateChange (data) {
      if (this.reputCondition.endDate && new Date(data).getTime() > new Date(this.reputCondition.endDate).getTime()) {
        this.messageTip('结束时间不能小于开始时间')
        this.reputCondition.endDate = ''
      }
    },
    endDateChange (data) {
      let st = this.reputCondition.startDate
      if (st) {
        if (new Date(data).getTime() < new Date(st).getTime()) {
          this.messageTip('结束时间不小于开始时间')
          this.reputCondition.endDate = ''
        } else if (new Date(data).getTime() - new Date(st).getTime() > 30 * ONEDAY) { // 开始和结束时间最多相差一月
          this.messageTip('时间范围须小于等于31天')
          this.reputCondition.endDate = ''
        }
      }
    },
    contractHandle() {
      this.reputCondition.contractNo = (this.reputCondition.contractNo || '').trim()
    },
    search () {
      if (!this.validCheck()) return
      let { orderCode, startDate, endDate } = this.reputCondition
      let finalParam = {
        ...this.reputCondition,
        orderCode,
        selectSlotRequest: {
          startDate,
          endDate
        }
      }
      // 传递最终接口请求传参
      this.$emit('search', finalParam)
      this.$store.commit('order/setForm', finalParam)
    },
    validCheck () {
      const { startDate, endDate, orderCode, contractNo } = this.reputCondition
      if (!orderCode) return this.messageTip('请输入订单编号后再搜索～')
      if (!startDate) return this.messageTip('请选择投放开始日期')
      if (!endDate) return this.messageTip('请选择投放结束日期')
      if (new Date(startDate).getTime() > new Date(endDate).getTime()) {
        return this.messageTip('结束日期须大于等于开始日期')
      }

      if (!contractNo) return this.messageTip('请输入合同编码', 2)

      return true
    }
  }
}
</script>

<style lang="sass" scoped>
.wifi_order_reput
  padding: 20px
  height: calc(100% - 66px)
  ::v-deep .el-form
    .el-form-item
      margin-bottom: 20px
      border: 1px solid #E9E9E9
      border-radius: 4px
      padding: 5px 0 5px 17px
      &.custom
        .el-input
          width: 230px
          input
            padding-right: 30px
      .el-form-item__label
        color: #282729
        font-weight: 600
        border-right: 1px solid #e9e9e9
        padding: 0 10px 0 0
        margin-top: 5px
        line-height: 20px

    .el-form-item__content
      .el-select
        .el-select__tags
          padding-left: 10px
        .el-input
          width: 210px
      .iconfont
        color: #999

    .el-select, .el-input
      &.input-date
        width: 92px
        padding-left: 0
        &:nth-of-type(2)
          margin: 0 5px
        > input
          padding-left: 10px
      input
        border: none
        padding-right: 0
        &:focus
          border-bottom: none !important
      .el-input__prefix
        display: none

    .el-select .el-tag
      margin: 2px 2px 2px 0

  .el-input--mini
    font-size: 14px

.time
  position: relative
  span.tip
    color: #999
    font-size: 12px
    position: absolute
    left: 68px
    bottom: -30px

.search
  width: 100%
  height: 40px
  line-height: 40px
  background: linear-gradient(315deg, rgba(255, 132, 109, 1) 0%, rgba(255, 57, 115, 1) 100%)
  border-radius: 4px
  font-weight: 400
  text-align: center
  color: #fff
  cursor: pointer
  margin-top: 30px
  margin-bottom: 10px
</style>
